import React, { useEffect, useState, Suspense } from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import ColorLens from '@material-ui/icons/ColorLens';
import { useDispatch, useSelector } from 'react-redux';
import { UserPrefferenceActions } from 'reducers';
import { withRouter } from 'react-router-dom';
import SettingsMenu from './Components/Settings';
import { isMobile } from 'app-constants';
import { useTranslation } from 'react-i18next';
import { Loader, ViewMode, TextWithSubtitle } from 'components';
import { Grid, AppBar, Switch, Toolbar, IconButton, Typography, FormControlLabel } from '@material-ui/core';

const useStyles = makeStyles((theme) => createStyles({
    root: {
      flexGrow: 1
    },
    menuButton: {
      marginRight: theme.spacing(2)
    },
    title: {
      flexGrow: 1,
      [theme.breakpoints.up('sm')]: {
        display: 'block'
      }
    }
  }));

const AppToolbar = ({ setTheme, history }) => {
  const classes = useStyles();
  const { i18n } = useTranslation();
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const { setDarkMode, setIsListView } = UserPrefferenceActions;

  const isDarkMode = useSelector((state) => state.userPrefference.isDarkMode);
  const isListView = useSelector((state) => state.userPrefference.isListView);

  const handleChange = (event) => {
    dispatch(setDarkMode(event.target.checked));
  };

  const handleChangeView = (value) => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      dispatch(setIsListView(value));
    }, 500);
  };

  useEffect(() => {
    setTheme(isDarkMode);
  }, [isDarkMode, setTheme]);

  return (
    <Suspense fallback={<Loader />}>
      <div className={classes.root}>
        <Loader isLoading={isLoading} />
        <AppBar
          style={{ background: 'linear-gradient(to right, #667eea, #764ba2)' }}
          color="default"
          position="fixed">
          <Toolbar>
            <IconButton
              style={{ color: '#fff' }}
              size="medium"
              onClick={() => history.push({ pathname: '/' })}
              edge="start"
              className={classes.menuButton}
              color="inherit"
              aria-label="open drawer">
              <ColorLens />
            </IconButton>
            <Typography style={{ color: '#fff' }} className={classes.title} variant="h6" noWrap>
              {'Artistic Home'}
            </Typography>

            <TextWithSubtitle noBr style={{ color: '#fff' }} subtitle="069 90 81 36" />
            <SettingsMenu
              component={
                <Grid container spacing={1} direction="column">
                  <Grid item>
                    {isMobile && <ViewMode isListView={isListView} handleChange={handleChangeView} />}
                  </Grid>
                  <Grid item>
                    {'Dark mode '}
                    <FormControlLabel
                      style={{ paddingLeft: 35 }}
                      control={<Switch onChange={handleChange} checked={isDarkMode} value="checkedB" />}
                    />
                  </Grid>
                  <Grid style={{ paddingTop: 8 }} item>
                    <SettingsMenu
                      button
                      component={
                        <Grid item>
                          <Typography style={{ padding: 8 }} onClick={() => i18n.changeLanguage('en')}>
                            English
                          </Typography>
                          <Typography style={{ padding: 8 }} onClick={() => i18n.changeLanguage('ro')}>
                            Româna
                          </Typography>
                          <Typography style={{ padding: 8 }} onClick={() => i18n.changeLanguage('ru')}>
                            Русский
                          </Typography>
                        </Grid>
                      }
                    />
                  </Grid>
                </Grid>
              }
            />
          </Toolbar>
        </AppBar>
      </div>
    </Suspense>
  );
};
export default withRouter(AppToolbar);
